import { Injectable } from '@angular/core';
import { Angular2PrestaService, Angular2PrestaQuery } from 'angular2-presta';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PrestashopService {

  queryProducts: Angular2PrestaQuery = {
    // define resource products, categories ...
    // check full list http://doc.prestashop.com/display/PS16/Web+service+reference
    resource: 'products',
    // return only fields you need
    // display : 'id,id_default_image,name,price,description_short,condition',
    // filter results
    // filter: {
    //  name: 'blouse',
    //  condition: 'new'
    // },
    // sort results
    sort: 'name_ASC' // ,
    // limit number of results or define range
    //  limit: '1'
  };
  queryVirtualProducts: Angular2PrestaQuery = {
    resource: 'products',
    filter: {
    //   active: 1,
      is_virtual: 1
    //   on_sale: 1
    },
    display: 'id, name',
    sort: 'name_ASC'
  };
  queryCategories: Angular2PrestaQuery = {
    resource: 'categories',
    sort: 'name_ASC'
  };
  // queryOrders: Angular2PrestaQuery = {
  //   resource: 'orders'
  // };
  queryContent: Angular2PrestaQuery = {
    resource: 'supply_order_details'
  };

  constructor(private _service: Angular2PrestaService) { }

  public getContent(): Observable<any> {
    return this._service.get(this.queryContent);
  }
  public getProducts(): Observable<any> {
    return this._service.get(this.queryProducts);
  }
  public getVirtualProducts(): Observable<any> {
    return this._service.get({
      resource: 'products',
      filter: {
      //   active: 1,
        is_virtual: 1
      //   on_sale: 1
      },
      display: 'id, name',
      sort: 'name_ASC'
    }).pipe(
      catchError((error) => {
        const errorMessage = error && error.message ? error.message : (error ? error.toString() : '');
        const isInternalServerError = (error && error.status === 500) || (errorMessage && errorMessage.indexOf('500') !== -1);

        if (isInternalServerError) {
          console.error('Prestashop getVirtualProducts ha retornat un error 500.', error);
          return of([]);
        }

        return throwError(error);
      })
    );
  }
  public getCategories(): Observable<any> {
    return this._service.get(this.queryCategories);
  }
  public getOrders(customer_id): Observable<any> {

   const queryOrders: Angular2PrestaQuery = {
      resource: 'orders',
      filter: {
        id_customer: customer_id
      }
    };
    return this._service.get(queryOrders);
  }
  public getOrderLines(orders) {
    const queryOrders: Angular2PrestaQuery = {
      resource: 'order_details',
      filter: {
        id_order: orders
      }
    };
    return this._service.get(queryOrders);
  }
  public getCustomer(email) {
    const queryCustomer: Angular2PrestaQuery = {
      resource: 'customers',
      filter: {
        email: email
      }
    };
    return this._service.get(queryCustomer);
  }
  public getLanguages() {
    const queryLanguages: Angular2PrestaQuery = {
      resource: 'languages'
    };
    return this._service.get(queryLanguages);
  }
  public getProductsIdsFromCustomer(email) {
    this.getCustomer(email).subscribe((c) => {
      if (c) {
        this.getOrders(c.id).subscribe(orders => {
          if (orders) {
            return this.getOrderLines(orders);
          } else {
            return null;
          }
        });
      } else {
        return null;
      }
    });
  }
}
